import 'jquery';
import Swiper, { Autoplay, Navigation, Keyboard, EffectFade } from 'swiper';
import AOS from 'aos';
Swiper.use([Autoplay, Navigation, Keyboard, EffectFade]);

const navigation = (el) => {
  const swiperClass = {
    nextEl: '.' + el + '-swiper__button--next',
    prevEl: '.' + el + '-swiper__button--prev',
  };
  return swiperClass;
};

let swiper;

$(window).on('load', function () {
  if ($('.footer__content__swiper').length) {
    swiper = new Swiper('.footer__content__swiper', {
      loop: true,
      autoplay: {
        delay: 3000,
        reverseDirection: true,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      allowTouchMove: false,
      slidesPerView: 1,
      spaceBetween: 200,
      speed: 600,
    });
  }
  if ($('.related-swiper').length) {
    swiper = new Swiper('.related-swiper', {
      loop: false,
      slidesPerView: 1.1,
      navigation: navigation('related-swiper'),
      keyboard: {
        enabled: true,
      },
      spaceBetween: 15,
      breakpoints: {
        1200: {
          slidesPerView: 2.135,
          spaceBetween: 30,
        },
        992: {
          slidesPerView: 2.115,
          spaceBetween: 30,
        },
        0: {
          slidesPerView: 1.1,
          spaceBetween: 15,
        },
      },
    });
  }
  if ($('.image-swiper').length) {
    swiper = new Swiper('.image-swiper', {
      loop: true,
      slidesPerView: 1,
      navigation: navigation('image-swiper'),
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
    });
  }
  if ($('.floorplan-swiper').length) {
    swiper = new Swiper('.floorplan-swiper', {
      loop: true,
      slidesPerView: 1,
      navigation: navigation('floorplan-swiper'),
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
    });
  }
  if ($('.page-head__wrapper__images').length) {
    swiper = new Swiper('.page-head__wrapper__images', {
      spaceBetween: 10,
      allowTouchMove: false,
      breakpoints: {
        992: {
          slidesPerView: 3,
        },
        0: {
          slidesPerView: 2,
        },
      },
    });
  }
  if ($('.reviews__wrapper__swiper').length) {
    swiper = new Swiper('.reviews__wrapper__swiper', {
      loop: true,
      freeMode: true,
      autoplay: {
        delay: 1,
        disableOnInteraction: false,
      },
      speed: 2500,
      freeModeMomentum: false,
      breakpoints: {
        1200: {
          slidesPerView: 4,
        },
        992: {
          slidesPerView: 3,
          speed: 5000,
        },
        768: {
          slidesPerView: 2,
        },
        0: {
          slidesPerView: 1,
        },
      },
    });
  }
  AOS.init({
    once: true,
    offset: 100,
  });
});

$(window).on('resize', function () {
  if (swiper) {
    swiper.update();
    AOS.refresh();
  }
});
